import { useDispatch, useSelector } from "react-redux";
import BoxComponent from "../../components/Box/Box";
import { fetchClientData } from "../../redux/reducers/user/slice";
import { fetchUserInfo } from "../../redux/reducers/trello/slice";
import { useEffect } from "react";

function ExportPage() {
  const dispatch = useDispatch();
  const { isClientFetched } = useSelector((state) => state.user);
  const { email, getUserLoading, fetched } = useSelector(
    (state) => state.trello
  );

  useEffect(() => {
    if (email && !isClientFetched) {
      dispatch(fetchClientData());
    }
  }, [email, isClientFetched, dispatch]);

  useEffect(() => {
    if (!fetched && !getUserLoading) {
      dispatch(fetchUserInfo());
    }
  }, [dispatch, fetched, getUserLoading]);
  
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <BoxComponent />
    </div>
  );
}

export default ExportPage;
